export default "__VITE_ASSET__ltdDpdrf__"